import React, { useState, useEffect } from 'react';
import { INCEPTION_RETURN_TYPE_MAPPING } from '../ParametersSummary';

export const TableCell = ({ getValue, row, column, table, index, width, headerType }) => {
  const initialValue = getValue();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const renderColumnContent = () => {
    if (column.id === 'calculation_type') {
      return INCEPTION_RETURN_TYPE_MAPPING[value] ?? '-';
    }
    return value ?? '-';
  };

  return (
    <div
      style={{
        width: '100%',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        maxWidth: '100%',
        padding: '4px 8px',
        lineHeight: '1.4',
      }}
      title={typeof value === 'string' && value.length > 50 ? value : ''}
    >
      {renderColumnContent()}
    </div>
  );
};
